<div class="character-list-container">
  <div class="section-header">角色列表</div>
  <div class="ui doubling six column grid">
    @for (item of itemsWithRelation; track item) {
      <div class="column">
        <div class="ui segment chara-card">
          <div class="image">
          <ui-responsive-image [src]="item.coverImage.url" [size]="{
            width: '100%',
            ratio: item.imageRatio,
            originalWidth: item.coverImage.width,
            originalHeight: item.coverImage.height
          }" [background]="item.coverImage.dormantColor"></ui-responsive-image>
          </div>
          <div class="chara-name">{{item.nameCn || item.name}}</div>
          <div class="chara-alt-name">{{item.nameCn ? item.name : ''}}</div>
          <div class="cast-list">
            @for (cast of item.castList; track cast) {
              <div class="cast-name">{{cast.nameCn || cast.name}}</div>
            }
          </div>
          <div class="ui bottom left attached mini label">{{item.relationType}}</div>
        </div>
      </div>
    }
  </div>
</div>
